import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DaveEventCardModule } from '../dave-event-card/dave-event-card.module';
import { DaveFilePreviewDialogModule } from '../dave-file-preview-dialog/dave-file-preview-dialog.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../dave-utils-module/app-filter-module/app-filter.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { TopButtonWrapperComponent } from '../top-button-wrapper/top-button-wrapper.component';
import { TaskPageComponent } from './components/task-page/task-page.component';
import { TasksBoardComponent } from './components/tasks-board/tasks-board.component';
import { DaveTasksRoutingModule } from './dave-tasks-routing.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';

@NgModule({
    declarations: [TasksBoardComponent, TaskPageComponent],
    imports: [
        CommonModule,
        DaveTasksRoutingModule,
        MatExpansionModule,
        MatChipsModule,
        FontAwesomeModule,
        MatListModule,
        MatButtonModule,
        MatCardModule,
        DaveSharedComponentsModule,
        MatDialogModule,
        AppButtonModule,
        DropzoneModule,
        MatTooltipModule,
        DaveEventCardModule,
        AppFilterModule,
        MatSidenavModule,
        DaveFilePreviewDialogModule,
        MatBadgeModule,
        DragDropModule,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TopButtonWrapperComponent,
        DaveLoadingModule,
    ],
    exports: [TasksBoardComponent],
})
export class DaveTasksModule {}
